import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {ListGroup, ListGroupItem} from 'reactstrap';
import trainingPhasesRemedialsActionCreators from '../../store/training-phases/action-creators/index';
import RemedialTrainingTable from './RemedialTrainingTable';
import DashboardRiskAlerts from "../dashboard/DashboardRiskAlerts";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import './ObsevationCardBody.scss'
import TimeChart from "../analytics/TimeChart";

function mapRiskAlerts(riskAlerts) {
  return riskAlerts.map(ra => ({
    ...ra,
    guid: ra.riskAlertGuid,
    report: {
      form: {
        type: ra.reportType
      }
    }
  }))
}

const accruedMap = (accrued) => {
  return accrued.reduce((acc, a) => {
    return [
      ...acc,
      ...Object.keys(a).map(key => ({key: key, value: a[key]}))
    ]
  }, [])
}

const visibleAccruedMap = (accrued, canViewCritiqueForms, settings) => {
  const mappedAccrued = accruedMap(accrued);

  if (canViewCritiqueForms) {
    return mappedAccrued;
  }

  const configuredCritiqueTypes = settings && settings.critiqueFormTypes || [];
  const critiqueFormTypes = [...configuredCritiqueTypes, 'ftc'];

  return mappedAccrued.filter(report => !critiqueFormTypes.includes(report.key));
}

const getHours = (timeSegments) => {
  return timeSegments && timeSegments.find(ts => ts.segment === 'total') || {total: 0, average: 0}
}
const ObservationCardBody = (props) => {
  const visibleAccrued = visibleAccruedMap(
    props.phase.accrued,
    props.canViewCritiqueForms,
    props.settings
  );

  return (
    <Fragment>

      <div className="observation-list">
        <div className="observation-list-col">
          <div className="observation-list-row">
            <span>Status:</span>
            <span>{props.phase.getCapitalized('status')}</span>
          </div>
          {!props.phase.fto ? (
            <div className="observation-list-row">
              <span>No {props.ftoShortLabel} assigned</span>
            </div>
          ) : (
            <div className="observation-list-row">
              <span>{props.ftoShortLabel}:</span>
              <span>{props.phase.getFtoFullName()}</span>
            </div>
          )}
        </div>
        <div className="observation-list-col">
          {visibleAccrued.map((a) =>
            <div key={a.key} className="observation-list-row">
              <span>Completed <span className="text-capitalize">{a.key}</span>s:</span>
              <span>{a.value}</span>
            </div>
          )}
          {!visibleAccrued.length &&
          <div className="observation-list-row">
            <span>There are no completed reports</span>
          </div>
          }
        </div>
      </div>
      {props.phase.hours && (
        <TimeChart
          phase={props.phase}
          hours={getHours(props.phase.time_segments).total}
          hidePhase={true}
        />
      )}
      {props.phase.riskAlerts.length > 0 &&
      <DashboardRiskAlerts
        showOitName
        hideActions
        shortReportsName
        emmbeded
        enableOpen
        icon="warning"
        title="Risk alerts"
        reports={mapRiskAlerts(props.phase.riskAlerts)}
        noReportsMessage="No risk alerts"
        hasWarnings={
          props.phase.riskAlerts && props.phase.riskAlerts.length > 0
        }
      />
      }
      {props.phase.remedials.length > 0 &&
        <RemedialTrainingTable
          onComplete={formData => props.completeRemedial(formData)}
          remedials={props.phase.getRemedials()}
        />
      }
    </Fragment>
  );
};

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
    settings: state.departmentSettings.settings,
    canViewCritiqueForms: departmentSettingsSelectors.canViewCritiqueForms(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    completeRemedial: (formData) => {
      return dispatch(trainingPhasesRemedialsActionCreators.completeRemedial(formData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ObservationCardBody);
